import React from "react";
import { PropTypes } from "prop-types";
import { connectWithLifecycle } from "react-lifecycle-component";
import OrderListComponent from "../container/OrderList";
import FloatingActionButton from "material-ui/FloatingActionButton";
import ContentAdd from "material-ui/svg-icons/content/add";

import { getOrdersMap } from "../../redux/selectors";
import uuid from "uuid";
import { push } from "react-router-redux";

const mapStateToProps = state => {
  const orders = getOrdersMap(state);
  return { orders: orders };
};

const mapDispatchToProps = dispatch => ({
  handleNewOrder: () => {
    dispatch(push(`/order/${uuid.v4()}`));
  },
  componentDidMount: () => {}
});

export const Selling = props => {
  const { handleNewOrder, orders } = props;
  const buttonStyle = {
    position: "fixed",
    bottom: 20,
    right: 20,
    zIndex: 2
  };
  return (
    <div>
      <FloatingActionButton
        secondary={true}
        style={buttonStyle}
        onClick={() => handleNewOrder()}
      >
        <ContentAdd />
      </FloatingActionButton>
      <OrderListComponent orders={orders} />
    </div>
  );
};

Selling.propTypes = {
  handleNewOrder: PropTypes.func.isRequired
};

const SellingPage = connectWithLifecycle(mapStateToProps, mapDispatchToProps)(
  Selling
);

export default SellingPage;



// WEBPACK FOOTER //
// ./src/components/pages/Selling.js